export default function ConfirmedBooking() {
  return (
    <>
      <article id="confirmed">
        <div className="container" style={{ textAlign: "center" }}>
          <h1>Booking Confirmed</h1>
          <p>Your reservation has been confirmed.</p>
          <p>You will receive a confirmation email shortly.</p>
        </div>
      </article>
    </>
  );
}
